/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { AlertDtoAction } from './alertDtoAction';

export interface AlertDto {
  /** Alert ID */
  id: string;
  /** Alert action */
  action: AlertDtoAction;
  /** Whether the alert has been read */
  read: boolean;
  /** Report ID associated with the alert */
  reportId: string;
  /** Report code */
  reportCode?: string;
  /** Creation date */
  createdAt: string;
  /** Last update date */
  updatedAt: string;
}
